import { render } from "./FooterLogo.vue?vue&type=template&id=0f68bea5&scoped=true"
import script from "./FooterLogo.vue?vue&type=script&lang=js"
export * from "./FooterLogo.vue?vue&type=script&lang=js"

import "./FooterLogo.vue?vue&type=style&index=0&id=0f68bea5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f68bea5"]])

export default __exports__